// extracted by mini-css-extract-plugin
module.exports = {"button":"Client_button__Eih6R"};